import React, { useCallback, useEffect, useRef } from 'react';

import classNames from 'classnames';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { BaseInput } from 'src/components/BaseInput';
import { selectSCMFlow } from 'src/redux/scm/scm.selectors';

import { EOrientationParam } from '../Orientation.types';
import { OrientationAdvancedController } from '../OrientationAdvancedController';
import s from './OrientationAdvanced.module.scss';
import { TOrientationAdvancedProps } from './OrientationAdvanced.types';

export const OrientationAdvanced: React.FC<TOrientationAdvancedProps> = ({
  theme,
  className,
  orientationParam,
  setOrientationParam,
}) => {
  const rendererRef = useRef<HTMLDivElement>(null);
  const controllerRef = useRef<OrientationAdvancedController>();
  const isSCM = useSelector(selectSCMFlow);
  // Listener of azimuth value change
  const handleOrientationParamChange = useCallback(
    ({ name, value }) => {
      const re = new RegExp(/^-?\d{0,3}(?:,\d{3})*(?:\.\d+)?$/);
      if (re.test(String(value))) {
        setOrientationParam({
          ...orientationParam,
          [name]: value,
        });
      }
    },
    [orientationParam, setOrientationParam],
  );

  useEffect(() => {
    if (controllerRef.current) controllerRef.current.update(orientationParam);
  }, [orientationParam]);

  // Initialize 3D container (only once call)
  useEffect(() => {
    if (rendererRef.current) {
      controllerRef.current = new OrientationAdvancedController(
        rendererRef.current,
        orientationParam,
        theme,
        'big',
      );
    }

    return () => {
      if (controllerRef.current) controllerRef.current.dispose();
    };
  }, [orientationParam, theme]);

  return (
    <div
      className={classnames(s.orientationAdvanced, className, {
        [s.light]: theme === 'light',
      })}>
      <div className={s.orientationAdvancedContainer} ref={rendererRef} />
      <div
        className={classnames(s.orientationAdvancedInputContainer, {
          [s.orientationSidebarInputWrapper]: theme === 'light',
        })}>
        <div
          className={classNames(s.orientationAdvancedInputWrapper, {
            [s.scmWrapper]: isSCM,
          })}>
          <BaseInput
            type="text"
            name={EOrientationParam.AZIMUTH}
            value={`${orientationParam.azimuth}`}
            onChange={handleOrientationParamChange}
            label="Azimuth"
            placeholder=""
            theme={isSCM ? 'filled-gray' : theme === 'light' ? 'filled-dark-gray' : 'line-light'}
            className={classNames(s.orientationAdvancedInput, {
              [s.scm]: isSCM,
            })}
          />
          <span>º</span>
        </div>
        <div
          className={classNames(s.orientationAdvancedInputWrapper, {
            [s.scmWrapper]: isSCM,
          })}>
          <BaseInput
            type="text"
            name={EOrientationParam.TILT}
            value={`${orientationParam.tilt}`}
            onChange={handleOrientationParamChange}
            label="Tilt"
            placeholder=""
            theme={isSCM ? 'filled-gray' : theme === 'light' ? 'filled-dark-gray' : 'line-light'}
            className={classNames(s.orientationAdvancedInput, {
              [s.scm]: isSCM,
            })}
          />
          <span>º</span>
        </div>
      </div>
    </div>
  );
};
